import news from '../assets/images/news.png';
import research from '../assets/images/research.png';
import tweets from '../assets/images/tweets.png';
import regulatory from '../assets/images/regulatory.png';

export default [
  {
    image: research,
    isComing: false,
    title: 'Research',
    description: 'Track stocks, commodities, forex, indices, private companies, financial topics to make the most informed decisions.'
  },
  {
    image: news,
    isComing: false,
    title: 'News Publications',
    description: 'Access to relevant financial information without delays and advertising from 3K+ sources across the web including FT, WSJ, Forbes, Twitter and regional media in different languages.'
  },
  {
    image: tweets,
    isComing: false,
    title: 'Tweets',
    description: 'Access to tweets from influencers and major market players without the need to filter tons of unnecessary media noise and repetitions.'
    
  },
  {
    image: regulatory,
    isComing: true,
    title: 'Regulatory Filings',
    description: 'The most recent updates on official reports that keep you in touch with the latest happenings in the business world.'
  }
]
